import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Info */}
          <div className="footer-col footer-brand-col">
            {/* <img src={config?.logo} alt="logo" className="footer-logo" /> */}
            <img src={`${process.env.PUBLIC_URL}/images/white.png`} alt="logo" className="footer-logo" />
            <p className="footer-text">
              Redefining everyday elegance. Discover our curated collection of
              modern jewelry and accessories, designed for the bold, the beautiful,
              and the uniquely you.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-links">
              <li>
                <Link to="/shop">Shop</Link>
              </li>
              <li>
                <Link to="/blog">Blogs</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="footer-col">
            <h6 className="footer-heading">Support</h6>
            <ul className="footer-links">

              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </  li>

              <li>
                <Link to="/return-and-refund-policy">
                  Return & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/cancellation-policy">Cancellation Policy</Link>
              </li>


            </ul>
          </div>

          {/* Contact / Newsletter */}

          <div className="footer-col">
            <h6 className="footer-heading">Stay Updated</h6>

            <div className="footer-contact-item">
              <FaEnvelope size={14} className="footer-icon" />
              <a href={`mailto:${config?.email}`} style={{ textDecoration: "none", color: "white" }}>
                {config?.email}
              </a>
            </div>

            <div className="footer-contact-item">
              <a
                href={config?.socialMedia?.instagram || "https://instagram.com"}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-insta-link"
              >
                <FaInstagram size={14} className="footer-icon" />
                <span style={{ textDecoration: "none" }}>Ivoreaaa</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <p className="footer-copyright">
            All Rights Reserved © 2026 Ivoréa.
          </p>

          <div className="col-md-6 text-md-end d-flex justify-content-center justify-content-md-end">
            <a
              href="https://axesell.com"
              className="floating-designer-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="floating-content">
                <img
                  src={`${process.env.PUBLIC_URL}/images/axesell_logo.png`}
                  className="floating-icon"
                  alt="Axesell"
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;